module.exports = __webpack_public_path__ + "fbf47e15e5cc1ecdef776b8894816da5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/match_legend.svg
// module id = 143
// module chunks = 0